// ─── MODÈLE BOOK APTE ─────────────────────────────────────────────────────────
// Administrable depuis le back-office APTE
// Ne pas coder les données directement dans les composants de présentation

export interface BookVideo {
  youtube_url: string;
  youtube_video_id: string;
  video_title: string;
  video_source: string;
  video_duration?: string;
  video_thumbnail?: string;
  video_transcript?: string;
  video_summary?: string;
  video_published_at?: string;
  display_order: number;
  is_primary_video: boolean;
  publication_status: 'draft' | 'published' | 'archived';
}

export interface Book {
  // Identité
  id: string;
  title: string;
  slug: string;
  author: string;
  publisher: string;
  isbn_paper: string;
  isbn_ebook?: string;
  publication_date?: string;
  page_count?: number;
  format?: string;

  // Prix
  indicative_price: string;
  currency: string;
  price_last_verified_at: string;

  // Descriptions
  short_description: string;
  full_description: string;

  // Images
  cover_image: string;
  cover_image_alt: string;
  cover_image_width?: number;
  cover_image_height?: number;
  image_credits?: string;

  // Lien externe
  purchase_url: string;
  purchase_cta_label: string;
  external_store_name: string;
  external_store_notice: string;
  external_link_enabled: boolean;
  external_link_url: string;
  external_link_label: string;
  external_link_target: '_blank';
  last_link_check_at?: string;

  // Vidéos
  videos: BookVideo[];

  // Relations
  related_articles?: string[];
  related_resources?: string[];

  // Classification
  audiences?: string[];
  themes?: string[];

  // SEO
  seo_title?: string;
  seo_description?: string;

  // Gestion éditoriale
  publication_status: 'draft' | 'published' | 'archived';
  display_order: number;
  featured: boolean;
}

// ─── DONNÉES OFFICIELLES DES LIVRES ───────────────────────────────────────────
// Source : APTE / Édilivre
// Prix indicatifs communiqués par l'éditeur — non garantis par APTE
// Dernière vérification : 2026-08-03

export const booksData: Book[] = [
{
  id: 'livre-001',
  title: "L'Épreuve du feu",
  slug: 'lepreuve-du-feu',
  author: 'Stéphane Saison',
  publisher: 'Édilivre',
  isbn_paper: '9782414814695',
  publication_date: '2025',
  format: 'Broché',

  indicative_price: '19,50 €',
  currency: 'EUR',
  price_last_verified_at: '2026-08-03',

  short_description:
  "Une réflexion engagée sur l'évolution du métier, la santé mentale dans les professions d'urgence et la reconnaissance des blessures invisibles.",
  full_description:
  "Dans ce second ouvrage, Stéphane Saison poursuit son travail de vérité et de mémoire.\n\nL'Épreuve du feu explore les séquelles invisibles laissées par le traumatisme psychique et le difficile parcours de reconstruction.\n\nAu-delà du récit personnel, l'ouvrage propose une réflexion sur l'évolution du métier, la santé mentale dans les professions d'urgence et la reconnaissance des blessures invisibles.",

  cover_image: '/assets/images/l-epreuve-du-feu-1785807457222.jpg',
  cover_image_alt: "Couverture du livre L'Épreuve du feu de Stéphane Saison",
  image_credits: 'Visuels fournis par APTE et Édilivre.',

  purchase_url:
  'https://librairie.edilivre.com/recit-temoignage/36020-l-epreuve-du-feu-9782414814695.html',
  purchase_cta_label: 'Acheter chez Édilivre',
  external_store_name: 'Édilivre',
  external_store_notice:
  "Vous allez être redirigé vers le site de l'éditeur. APTE ne traite ni la commande, ni le paiement, ni la livraison.",
  external_link_enabled: true,
  external_link_url:
  'https://librairie.edilivre.com/recit-temoignage/36020-l-epreuve-du-feu-9782414814695.html',
  external_link_label: 'Acheter chez Édilivre',
  external_link_target: '_blank',
  last_link_check_at: '2026-08-03',

  videos: [
  {
    youtube_url: 'https://www.youtube.com/watch?v=zHz9ON6S5CY',
    youtube_video_id: 'zHz9ON6S5CY',
    video_title: "L'épreuve du feu — Le témoignage d'un sapeur-pompier — Édilivre",
    video_source: 'Édilivre',
    video_summary:
    "Présentation officielle du livre L'Épreuve du feu par Édilivre. Témoignage de Stéphane Saison, sapeur-pompier et auteur.",
    display_order: 1,
    is_primary_video: true,
    publication_status: 'published'
  },
  {
    youtube_url: 'https://www.youtube.com/watch?v=1qdsf2dxMW0',
    youtube_video_id: '1qdsf2dxMW0',
    video_title:
    'Hondelatte Raconte : le sapeur-pompier grièvement brûlé dans un incendie — récit intégral',
    video_source: 'Europe 1 — Hondelatte Raconte',
    video_summary:
    "Un récit complémentaire pour comprendre le parcours personnel à l'origine des engagements de l'auteur et de l'association APTE.",
    display_order: 2,
    is_primary_video: false,
    publication_status: 'published'
  }],


  related_articles: [],
  related_resources: [],
  audiences: ['Sapeurs-pompiers', 'Professionnels de santé', 'Tous publics'],
  themes: ['Psychotraumatisme', 'Épuisement opérationnel', 'Prévention'],

  seo_title: "L'Épreuve du feu — Stéphane Saison — Livre APTE",
  seo_description:
  "L'Épreuve du feu de Stéphane Saison : une réflexion sur la santé mentale dans les professions d'urgence et la reconnaissance des blessures invisibles. Disponible chez Édilivre.",

  publication_status: 'published',
  display_order: 1,
  featured: true
},
{
  id: 'livre-002',
  title: 'Le Tas',
  slug: 'le-tas',
  author: 'Stéphane Saison',
  publisher: 'Édilivre',
  isbn_paper: '9782414815210',
  publication_date: '2025',
  format: 'Broché',

  indicative_price: '16,90 €',
  currency: 'EUR',
  price_last_verified_at: '2026-08-03',

  short_description:
  "Un récit consacré à l'intervention, à l'après et au prix humain que l'uniforme ne montre pas toujours.",
  full_description:
  "Il y a l'intervention. Et il y a l'après.\n\nDans Le Tas, Stéphane Saison revient sur l'événement opérationnel qui a marqué son parcours et sur les conséquences psychiques qui peuvent persister après la mission.\n\nLe récit met en lumière ce que les uniformes taisent parfois : le prix humain de l'engagement et la nécessité d'écouter celles et ceux que l'on croit solides.",

  cover_image: '/assets/images/le-tas-1785807457229.jpg',
  cover_image_alt: 'Couverture du livre Le Tas de Stéphane Saison',
  image_credits: 'Visuels fournis par APTE et Édilivre.',

  purchase_url:
  'https://librairie.edilivre.com/recit-temoignage/36084-le-tas-9782414815210.html',
  purchase_cta_label: 'Acheter chez Édilivre',
  external_store_name: 'Édilivre',
  external_store_notice:
  "Vous allez être redirigé vers le site de l'éditeur. APTE ne traite ni la commande, ni le paiement, ni la livraison.",
  external_link_enabled: true,
  external_link_url:
  'https://librairie.edilivre.com/recit-temoignage/36084-le-tas-9782414815210.html',
  external_link_label: 'Acheter chez Édilivre',
  external_link_target: '_blank',
  last_link_check_at: '2026-08-03',

  videos: [],

  related_articles: [],
  related_resources: [],
  audiences: ['Sapeurs-pompiers', 'Aidants', 'Tous publics'],
  themes: ['Psychotraumatisme', 'Accompagnement', "Retour d'expérience"],

  seo_title: 'Le Tas — Stéphane Saison — Livre APTE',
  seo_description:
  "Le Tas de Stéphane Saison : un récit sur l'intervention, l'après et le prix humain que l'uniforme ne montre pas toujours. Disponible chez Édilivre.",

  publication_status: 'published',
  display_order: 2,
  featured: true
}];


export function getBookBySlug(slug: string): Book | undefined {
  return booksData.find((b) => b.slug === slug && b.publication_status === 'published');
}

export function getPublishedBooks(): Book[] {
  return booksData.
  filter((b) => b.publication_status === 'published').
  sort((a, b) => a.display_order - b.display_order);
}